// Popup for selecting fields before generate PDF
import React from 'react';
import { useInternationalization } from '../../features/i18n';
import { PopupBasic } from './basic';

const FieldPopup = ({children, onClose}) => {
  const { translate } = useInternationalization()

  return (
    <PopupBasic
      onClose={onClose}
      title={translate('DASHBOARD', 'visibility_settings')}
    >
      {children}
    </PopupBasic>
  )
}

export default FieldPopup
